import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
/**
 * https://coryrylan.com/blog/creating-a-custom-debounce-click-directive-in-angular
 *
 * @whatItDoes provides a directive based approach to debouncing click events on
 * an arbitrary element
 *
 * @howToUse add the directive and output to any element:
 * ```
 * <button uzDebounceClick (debounceClick)="clickHandler()" [debounceTime]="700">Debounced Click</button>
 * ```
 * and optionally configure the debounceTime through the input property
 */
@Directive({
  selector: '[uzDebounceClick]',
  standalone: true
})
export class DebounceClickDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 200;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;

  constructor() {}

  @HostListener('click', ['$event'])
  clickEvent(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.clicks.next(event);
  }

  ngOnInit() {
    // updated to throttleTime to avoid the initial click delay with debounceTime
    this.subscription = this.clicks.pipe(throttleTime(this.debounceTime)).subscribe(e => this.debounceClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
